import { formatIntToCurrency } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import type { CashLocationMutation } from "~/providers/cash-location-provider";
import type { ColumnDefWithTotal } from "~/types";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { api } from "~/lib/api";
import { useReportStore } from "~/stores/use-report-store";

export const Route = createFileRoute("/_main/reports/_layout/mutation")({
  component: MutationReports,
});

function MutationReports() {
  const { range } = useReportStore();

  const { t } = useTranslation("common");

  const { data: reportData } = api.report.getMutations.useQuery({
    start: range.from,
    end: range.to,
  });

  const columns: ColumnDefWithTotal<CashLocationMutation>[] = [
    {
      id: t("Report.Mutation.date"),
      accessorKey: "createdAt",
      filterFn: "includesString",
      sortingFn: (rowA, rowB) => {
        return (
          rowA.original.createdAt.getTime() - rowB.original.createdAt.getTime()
        );
      },
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.Mutation.date")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{format(report.createdAt, "P")}</p>;
      },
    },
    {
      id: t("Report.Mutation.description"),
      accessorKey: "comment",
      filterFn: "includesString",

      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.Mutation.description")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.comment}</p>;
      },
    },
    {
      id: t("Report.Mutation.category"),
      accessorKey: "category",
      filterFn: "includesString",

      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.Mutation.category")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.comment}</p>;
      },
    },
    {
      id: t("Report.Mutation.type"),
      accessorKey: "type",
      filterFn: "includesString",

      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.Mutation.type")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.type}</p>;
      },
    },
    {
      id: t("Report.Mutation.amount"),
      accessorKey: "value",
      filterFn: "includesString",

      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.Mutation.amount")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{formatIntToCurrency(report.value, false)}</p>;
      },
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <DataTable
        defaultSorting={[{ id: t("Report.Mutation.date"), desc: false }]}
        pdfExport={{
          filename: "mutation-report",
        }}
        csvExport={{
          filename: "mutation-report",
        }}
        columns={columns}
        data={reportData ?? []}
      />
    </div>
  );
}
